var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mail_FILL1_wght400_GRAD0_opsz48",
    d: "M83-768a2.878,2.878,0,0,1-2.1-.9A2.878,2.878,0,0,1,80-771v-26a2.878,2.878,0,0,1,.9-2.1A2.878,2.878,0,0,1,83-800h34a2.878,2.878,0,0,1,2.1.9,2.878,2.878,0,0,1,.9,2.1v26a2.878,2.878,0,0,1-.9,2.1,2.878,2.878,0,0,1-2.1.9Zm17-15.1,17-11.15V-797l-17,10.9L83-797v2.75Z",
    transform: "translate(-80 800)",
    fill: "#22638d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.8f0448acb1e459bd8141ca9088f713d3.svg";
export { ForwardRef as ReactComponent };